import { Section } from "design-system/molecules/Section"
import { UpdateCampaignSchemaFrontend } from "modules/campaigns/hooks/useCampaignForm"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CampaignDetailResponseDataSchema, ChannelEnum } from "schema"
import { z } from "zod"

import { ApiChannelForm } from "./forms/ApiChannelForm"
import { GmailChannelForm } from "./forms/GmailChannelForm"
import { OutlookChannelForm } from "./forms/OutlookChannelForm"

type Props = {
  isEditable: boolean
  campaign: z.infer<typeof CampaignDetailResponseDataSchema>
}

export function ChannelConfigSubTab({ isEditable, campaign }: Props) {
  const { t } = useTranslation()
  const form = useFormContext<z.infer<typeof UpdateCampaignSchemaFrontend>>()
  const channel = form.watch("channel")

  if (channel === ChannelEnum.Api) {
    return (
      <Section
        title={t("campaigns.configuration.setup.config.api.title")}
        description={t("campaigns.configuration.setup.config.api.description")}
        className="gap-3"
      >
        <ApiChannelForm campaign={campaign} isDisabled={!isEditable} />
      </Section>
    )
  }

  if (channel === ChannelEnum.Gmail) {
    return (
      <Section
        title={t("campaigns.configuration.setup.config.gmail.title")}
        description={t("campaigns.configuration.setup.config.gmail.description")}
        className="gap-3"
      >
        <GmailChannelForm isDisabled={!isEditable} />
      </Section>
    )
  }

  if (channel === ChannelEnum.Outlook) {
    return (
      <Section
        title={t("campaigns.configuration.setup.config.outlook.title")}
        description={t("campaigns.configuration.setup.config.outlook.description")}
        className="gap-3"
      >
        <OutlookChannelForm isDisabled={!isEditable} />
      </Section>
    )
  }

  return null
}
